'use client'
import { useState } from 'react'
import tailwindConfig from '@tailwind.config'

const FaqComponent = ({ faqs, title }) => {
    const style = {
        color: tailwindConfig.theme.extend.colors.secondary,
    };

    const [openIndex, setOpenIndex] = useState(null);

    if (!faqs || faqs.length === 0) {
        return null;
    }

    const toggleFaq = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className='mb-3 pb-3'>
            {title && (
                <h2 className='text-maincolor font-semibold text-xl'>{title}</h2>
            )}
            <div>
                {faqs.map((faq, index) => {
                    const isOpen = openIndex === index;
                    return (
                        <div key={index}>
                            <div className='py-3'>
                                <button
                                    type="button"
                                    onClick={() => toggleFaq(index)}
                                    className='w-full flex justify-between items-center text-left cursor-pointer'
                                >
                                    <h3 style={style} className='text-xl font-semibold'>
                                        {faq.question}
                                    </h3>
                                    <span
                                        style={style}
                                        className={`text-2xl ml-3 shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`}
                                    >
                                        +
                                    </span>
                                </button>
                                <div
                                    className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[1000px] opacity-100 mt-1' : 'max-h-0 opacity-0'
                                        }`}
                                >
                                    <p className='text-xl'>
                                        {faq.answer}
                                    </p>
                                </div>
                            </div>
                            {index < faqs.length - 1 && (
                                <div className='w-full border-b-[1px]'></div>
                            )}
                        </div>
                    );
                })}
            </div>
        </section>
    )
}

export default FaqComponent